import { FC } from "react";
import { useLanguage } from "../../context/LanguageContext";
import Logo from "../../assets/guides.svg";
import { Outlet, useLocation } from "react-router-dom";
import Customise from "../../assets/guru-guides-customise.png";
import Memory from "../../assets/guru-guides-memory.png";
import { LinkCard } from "../../compositions/LinkCard";
import { PageHeading } from "../../compositions/PageHeading";
// import styles from "./index.module.css";

const Content = () => {
  const { t } = useLanguage();
  return (
    <>
      <LinkCard
        title={t("guides.customise-page.title")}
        to="/guides/customise"
        description={t("guides.customise-page.description")}
        stretch
      >
        <div
          style={{
            padding: "var(--space-300) var(--space-500) 0",
          }}
        >
          <img style={{ width: "100%", height: "auto" }} src={Customise} alt="Customise" />
        </div>
      </LinkCard>

      <LinkCard
        title={t("guides.benefits-page.title")}
        to="/guides/benefits"
        description={t("guides.benefits-page.description")}
        stretch
      >
        <div
          style={{
            padding: "var(--space-300) var(--space-500)",
          }}
        >
          <img style={{ width: "100%", height: "auto" }} src={Memory} alt="setup" />
        </div>
      </LinkCard>
    </>
  );
};

const Header = () => {
  const { t } = useLanguage();
  return (
    <>
      <mui-v-stack space="var(--space-500)">
        <PageHeading page={t("guides.title")} logo={Logo}>
          <mui-badge variant="positive">{t("figma-plugin.title")}</mui-badge>
        </PageHeading>
        <mui-body size="large">{t("guides.description")}</mui-body>
      </mui-v-stack>
      <mui-h-stack space="var(--space-300)">
        <mui-link variant="secondary" href="https://guides.gurusuite.xyz/" target="_blank">
          {t("guides.online")}
        </mui-link>
        <mui-link
          variant="primary"
          href="https://www.figma.com/community/plugin/1471341082690554711/guru-guides"
          target="_blank"
        >
          {t("guides.install")}
        </mui-link>
      </mui-h-stack>
    </>
  );
};

export const Guides: FC<{}> = () => {
  const location = useLocation();
  const isRootGuides = location.pathname === "/guides";

  return (
    <div className="landing-page_outer">
      <div className="landing-page_inner">
        {isRootGuides && (
          <mui-v-stack space="var(--space-600)">
            <mui-responsive breakpoint="800">
              <mui-grid slot="showAbove" space="var(--space-700)" col="1fr auto">
                <Header />
              </mui-grid>
              <mui-v-stack slot="showBelow" space="var(--space-600)">
                <Header />
              </mui-v-stack>
            </mui-responsive>

            <mui-responsive breakpoint="800">
              <mui-grid slot="showAbove" space="var(--space-800)" col="1fr 1fr">
                <Content />
              </mui-grid>
              <mui-v-stack slot="showBelow" space="var(--space-500)">
                <Content />
              </mui-v-stack>
            </mui-responsive>
          </mui-v-stack>
        )}
        <Outlet />
      </div>
    </div>
  );
};

export default Guides;
